import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { PROJECT_ORGANISATION_ROLE as orgaRole } from '../../../utils/constant';
import { Tooltip } from '@material-ui/core';
import { Icon } from 'front-onceforall-core';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ProjectSelectRoleCard(_ref) {
  let {
    isSelected,
    role,
    onRoleSelection
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "col-lg-4 mb-2",
    "data-id": `${role}-selection`,
    children: /*#__PURE__*/_jsxs("div", {
      "data-id": "card-role-selection",
      className: "box flex-container column space-between",
      style: isSelected ? {
        border: '1px solid',
        height: '100%'
      } : {
        height: '100%'
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex-container column",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "active",
          children: /*#__PURE__*/_jsx(Translate, {
            value: `project.role.${role}.title`
          })
        }), /*#__PURE__*/_jsxs("ul", {
          className: "mb-5 mt-0",
          children: [/*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Translate, {
              value: `project.role.${role}.firstPoint`
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Translate, {
              value: `project.role.${role}.secondPoint`
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsx(Translate, {
              value: `project.role.${role}.thirdPoint`
            })
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "inline-container space-between",
        children: /*#__PURE__*/_jsx(Tooltip, {
          "data-id": `${role}-project-tooltip`,
          title: /*#__PURE__*/_jsx(Translate, {
            value: `project.role.${role}.tooltip`
          }),
          children: /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsxs("button", {
              type: "submit",
              className: "large secondary inline-container",
              "data-id": `${role}-button`,
              onClick: () => onRoleSelection(role),
              children: [/*#__PURE__*/_jsx(Translate, {
                value: "project.role.choose"
              }), /*#__PURE__*/_jsx(Icon, {
                icon: 'check'
              })]
            })
          })
        })
      })]
    })
  });
}
ProjectSelectRoleCard.propTypes = {
  isSelected: PropTypes.bool,
  role: PropTypes.oneOf(Object.values(orgaRole)),
  onRoleSelection: PropTypes.func.isRequired
};
export default ProjectSelectRoleCard;